export default __webpack_public_path__ + "save-contact.svg";